import { CloneTableToolbar } from '@/features/shared/components/cloneTable/CloneTableToolbar';
import {
  cloneColumnOptions,
  cloneDefaultColumnVisibilityModel,
  cloneDefaultSortDirection,
  cloneDefaultSortKey,
  type CloneSortDirection,
  type CloneSortKey,
  cloneSortOptions,
  cloneStatusOptions,
} from '@/features/tests/pages/testsPageCloneConfig';
import type { CloneDateQuickFilter } from '@/features/shared/hooks/useCloneDateWindow';
import type { GridColumnVisibilityModel } from '@/ui/primitives';
import type { TestExecutionStatus } from '@flowqa/shared';
import type { Dayjs } from 'dayjs';
import type { ReactElement } from 'react';

type CloneToolbarProps = {
  title?: string;
  onDebouncedCloneSearchChange: (value: string) => void;
  columnVisibilityModel: GridColumnVisibilityModel;
  onColumnVisibilityModelChange: (nextModel: GridColumnVisibilityModel) => void;
  sortKey: CloneSortKey;
  sortDirection: CloneSortDirection;
  onSortChange: (sortKey: CloneSortKey, sortDirection: CloneSortDirection) => void;
  filterStatuses: TestExecutionStatus[];
  onFilterStatusesChange: (next: TestExecutionStatus[]) => void;
  filterSuites?: string[];
  onFilterSuitesChange?: (next: string[]) => void;
  suiteOptions?: Array<{ value: string; label: string }>;
  filterTags: string[];
  onFilterTagsChange: (next: string[]) => void;
  dateQuickFilter: CloneDateQuickFilter;
  onDateQuickFilterChange: (next: CloneDateQuickFilter) => void;
  fromDate: Dayjs | null;
  toDate: Dayjs | null;
  onFromDateChange: (next: Dayjs | null) => void;
  onToDateChange: (next: Dayjs | null) => void;
  availableTags: string[];
};

export const CloneToolbar = (props: CloneToolbarProps): ReactElement => (
  <CloneTableToolbar<CloneSortKey, TestExecutionStatus>
    title="Tests"
    searchAriaLabel="Search tests, suites, tags"
    defaultColumnVisibilityModel={cloneDefaultColumnVisibilityModel}
    columnOptions={cloneColumnOptions}
    defaultSortKey={cloneDefaultSortKey}
    defaultSortDirection={cloneDefaultSortDirection}
    sortOptions={cloneSortOptions}
    statusOptions={cloneStatusOptions}
    {...props}
  />
);

export type { CloneDateQuickFilter };
